export const GLOBAL_TABLE_PAGINATION_PER_PAGE = 'global.table.pagination.per-page';

export const KEYWORD_MENU_ROUTES = [
  'keyword-research',
  'rank-checker',
  'tags',
  'trend-buzz',
  'trending',
  'shop-info',
  'traffic-stats-parent',
  'categories',
  'ai-listing-helper',
  'keyword-lists',
  'listing-audit',
  'bulk-keyword-tool',
];
